import { render, staticRenderFns } from "./category-filter-drawer.vue?vue&type=template&id=db41fae8"
import script from "./category-filter-drawer.vue?vue&type=script&lang=js"
export * from "./category-filter-drawer.vue?vue&type=script&lang=js"
import style0 from "./category-filter-drawer.vue?vue&type=style&index=0&id=db41fae8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports